var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"sliderWrapper",staticClass:"e-auto-slider__wrapper",class:{ 'is-ready': _vm.isReady }},[_c('div',{ref:"sliderTrack",staticClass:"e-auto-slider__track"},[_vm._l((2),function(i){return [_vm._t("default")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }